import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import UserService from "../../../../../services/UserService";
import axios from "axios";
import styled from "styled-components";
import Modal from "react-modal";
import {Container, Row, Spinner} from "react-bootstrap";
import ModalCloseButton from "../../../../common/modal/ModalCloseButton";
import OverlayToolTip from "../../../common/toolTip/OverlayToolTip";
import {SlRefresh} from "react-icons/sl";
import BoothSyncItemView from "../../../franchiseMenu/modals/modalInner/BoothSyncItemView";
import useAxios from "../../../../../customHooks/useAxios";

const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '650px',
        height: '650px',
        margin: 'auto'
    }
};

const MenuName = styled.div`
  height: 40px;
  font-size: 15px;
  color: #757575;
  text-align: left;
`;

const FilterButton = styled.button`
  border: 1px solid ${(props) => props.color ? props.color : "#c2c2c2"};
  border-radius: 10px;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : "white"};
  color: ${(props) => props.color ? props.color : "#c2c2c2"};
  transition: all ease-in-out 0.2s;
  margin-left: ${(props) => props.marginLeft ? props.marginLeft : "0px"};
  padding: 3px 15px;
  font-size: 14px;
  
  &:focus {
    outline: none;
  }
  
  &:hover {
    background-color: ${(props) => props.hoverColor ? props.hoverColor : "#eeeeee"};
  }
`;

const RefreshButton = styled.button`
  border: none;
  background: none;
  color: #fc7242;
  transition: all ease-in-out 0.2s;
  margin-left: auto;
  
  &:focus {
    outline: none;
  }
  
  &:hover {
    color: #ffcccb;
  }
`;

const BoothMenuSyncForBranchView = ({ isOpen, setIsOpen, branchId, menuId }) => {

    /** New : axios hook */
    const { isAxiosLoading, axiosCall } = useAxios();

    const { t } = useTranslation();

    /* states */
    const [menuInfo, setMenuInfo] = useState({});
    const [boothSyncInfoList, setBoothSyncInfoList] = useState([]);
    const [targetBoothSync, setTargetBoothSync] = useState("NOT_DONE");

    /* loading */
    const [isRefreshLoading, setIsRefreshLoading] = useState(false);

    /* fetch data */
    const fetchBoothSyncList = async () => {
        try {
            await setIsRefreshLoading(true);
            const res = await axiosCall(
                "GET",
                '/branch-menu/branch/:1/menu/:2/booth-sync-status',
                [branchId, menuId],
                {},
                null,
                {},
                "default"
            );
            let newSyncList = res.data.item['boothSyncList'];
            let newMenuInfo = res.data.item['menuInfo'];
            await setMenuInfo(newMenuInfo);
            await setBoothSyncInfoList(newSyncList);
            await setIsRefreshLoading(false);
        } catch (e) {
            console.log(e);
            await setIsRefreshLoading(false);
            setBoothSyncInfoList([]);
        }
    };

    /* filter function */
    const filterSyncList = (syncList) => {
        return syncList.filter((syncInfo) => {
            if (targetBoothSync === "DONE") {
                return syncInfo['boothMenuSyncInformation']['synchronized'];
            } else {
                return !syncInfo['boothMenuSyncInformation']['synchronized'];
            }
        });
    };

    /* effects */
    useEffect(() => {
        fetchBoothSyncList().then(() => {
            setTargetBoothSync("NOT_DONE");
        });
    }, [isOpen]);

    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                setIsOpen(false);
            }}
        >
            <Container fluid>
                <Row>
                    <ModalCloseButton
                        title={t("menu.franchiseMenu.boothSync.title")}
                        setIsOpen={setIsOpen}
                    />
                </Row>
                {
                    (Object.keys(menuInfo).length !== 0) &&
                    <Row>
                        <MenuName>
                            {menuInfo[t("language.dataKey.menu.franchise.info.name")]}
                        </MenuName>
                    </Row>
                }
                {
                    (Object.keys(menuInfo).length === 0) &&
                    <Row>
                        <MenuName>
                            <Spinner size={"sm"} />
                        </MenuName>
                    </Row>
                }
                <Row>
                    {/* filter buttons */}
                    <div
                        style={{
                            width: '100%',
                            display: 'inline-flex'
                        }}
                    >
                        {/* not-done */}
                        <FilterButton
                            color={(targetBoothSync === "DONE") ? "#fc7242" : null}
                            backgroundColor={(targetBoothSync === "DONE") ? "#fff1ec" : null}
                            hoverColor={(targetBoothSync === "DONE") ? "#fff1ec" : null}
                            onClick={() => setTargetBoothSync("DONE")}
                        >
                            {t("menu.franchiseMenu.boothSync.detail.syncDone")}
                        </FilterButton>
                        {/* done */}
                        <FilterButton
                            color={(targetBoothSync === "NOT_DONE") ? "#fc7242" : null}
                            backgroundColor={(targetBoothSync === "NOT_DONE") ? "#fff1ec" : null}
                            hoverColor={(targetBoothSync === "NOT_DONE") ? "#fff1ec" : null}
                            marginLeft={"10px"}
                            onClick={() => setTargetBoothSync("NOT_DONE")}
                        >
                            {t("menu.franchiseMenu.boothSync.detail.syncNotDone")}
                        </FilterButton>
                        <OverlayToolTip
                            text={t("menu.franchiseMenu.boothSync.button.refresh")}
                            direction={"top"}
                        >
                            <RefreshButton
                                onClick={() => fetchBoothSyncList()}
                            >
                                <SlRefresh
                                    size={"25"}
                                />
                            </RefreshButton>
                        </OverlayToolTip>
                    </div>
                </Row>
                <Row>
                    <div
                        style={{
                            width: '100%',
                            height: '420px',
                            overflow: 'auto',
                            padding: '5px',
                            marginTop: '10px'
                        }}
                    >
                        {
                            isRefreshLoading &&
                            <div
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    paddingTop: '30px'
                                }}
                            >
                                <Spinner
                                    size={"sm"}
                                    style={{
                                        color: "#757575"
                                    }}
                                />
                            </div>
                        }
                        {
                            (filterSyncList(boothSyncInfoList).length === 0) && (!isRefreshLoading) &&
                            <div
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    paddingTop: '30px'
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '14px',
                                        color: '#757575'
                                    }}
                                >
                                    {t("menu.franchiseMenu.boothSync.message.noSyncInfo")}
                                </span>
                            </div>
                        }
                        {
                            (!isRefreshLoading) &&
                            (filterSyncList(boothSyncInfoList).length > 0) &&
                            filterSyncList(boothSyncInfoList).map((boothSyncInfo) => {
                                return (
                                    <BoothSyncItemView
                                        key={boothSyncInfo['boothMenuSyncInformation']['menuBoothSyncId']}
                                        boothInfo={boothSyncInfo['boothInformation']}
                                        syncInfo={boothSyncInfo['boothMenuSyncInformation']}
                                        setIsOpen={setIsOpen}
                                        onRefresh={fetchBoothSyncList}
                                        franchiseId={""}
                                        isUpdatePossible={false}
                                    />
                                );
                            })
                        }
                    </div>
                </Row>
            </Container>
        </Modal>
    );
};

export default BoothMenuSyncForBranchView;